import * as React from 'react';
import styled from 'styled-components'

interface IProps
    extends React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement> {
}

const StickyBottomWrapperDefault: React.SFC<IProps> = (props) => {

    const { ...DivProps } = props;

    return (<div {...DivProps} />)

};

const StickyBottomWrapper = styled(StickyBottomWrapperDefault)`
    position: sticky;
    bottom: 0;
`;

export default StickyBottomWrapper;



// WEBPACK FOOTER //
// ./src/presentation/common/atom/wrapper/sticky_bottom_wrapper.tsx